var ApiUtil = require('./api-util')

exports.featureList = function(page, count, is_sponsored) {
  const data = {
    page: page,
    count: count,
    is_sponsored: is_sponsored
  }

  return ApiUtil.request('get', '/api/feature/list.json', data)
}



// WEBPACK FOOTER //
// ./webroot/js/api/feature.js